
import * as React from 'react';


export function getNoStandortMessage(): JSX.Element {
    return <div style={{padding: '20px'}}>Bitte aktivieren Sie die Erfassung von Energiedaten für mind. 1 Standort!</div>;
}
